import { ApiCartAddress } from "@nusrif/types";
interface Props {
  address: ApiCartAddress;
}
export const DeliveryAddressCard = ({ address }: Props) => (
  <div className="p-4 bg-white rounded-lg border border-gray-100 shadow-sm">
    <h3 className="text-lg font-semibold text-black mb-3">Delivery Address</h3>
    <div className="space-y-1">
      <p className="font-medium text-black">{address.fullName}</p>
      <p className="text-sm text-gray-600">{address.phoneNumber}</p>
      <p className="text-sm text-gray-700">
        {address.streetLine1}
        {address.streetLine2 && `, ${address.streetLine2}`}
      </p>
      <p className="text-sm text-gray-700">
        {address.city}, {address.province} - {address.postalCode}
      </p>
    </div>
  </div>
);
